import React from "react";
import useIdleTimeout from "../hooks/useIdleTimeout";
import AccessPINOverlay from "./AccessPINModal";
import { useIdleContext } from "../context/IdleContext";

/**
 * While locked, show the PIN overlay on top of the app but keep the app
 * mounted in the DOM. This preserves all React state (form data, etc.)
 * so the user can resume exactly where they left off after unlocking.
 *
 * Note: the overlay covers 100vw/100vh at z-index 100000, so the hidden
 * content underneath is not visually accessible without the PIN.
 */
const IdleTimeoutWrapper = ({ children }) => {
  useIdleTimeout(900000);
  const { showIdleModal } = useIdleContext();

  return (
    <>
      {/* Always keep children mounted to preserve React state */}
      <div
        aria-hidden={showIdleModal}
        style={
          showIdleModal
            ? { visibility: "hidden", pointerEvents: "none" }
            : undefined
        }
      >
        {children}
      </div>

      {/* PIN overlay renders on top when locked */}
      {showIdleModal && <AccessPINOverlay listenToIdle />}
    </>
  );
};

export default IdleTimeoutWrapper;
